import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export const routes = [
	{
		path: '/login',
		name: 'Login',
		component: () => import('@/views/login'),
		meta: { title: '登录' },
		hidden: true
	},
	{
		path: '/',
		component: () => import('@/layout/adminLayout'),
		redirect: '/users',
		children: [
			{ path: '/users', name: 'Users', component: () => import('@/views/user/UserList'), meta: { title: '用户列表' } },
			{ path: '/users/:id/timeline', name: 'UserTimeline', component: () => import('@/views/user/UserTimeline'), meta: { title: '用户时间线' } },
			{ path: '/users/:id/messages', name: 'UserMessages', component: () => import('@/views/user/UserMessages'), meta: { title: '用户留言板' } },
			{ path: '/vip-records', name: 'VIPRecords', component: () => import('@/views/user/VIPRecords'), meta: { title: '年费开通记录' } },
			{ path: '/feedbacks', name: 'Feedbacks', component: () => import('@/views/user/UserFeedbacks'), meta: { title: '用户反馈' } },
			{ path: '/user-login-logs', name: 'UserLoginLogs', component: () => import('@/views/user/UserLoginLogs'), meta: { title: '用户登录日志' } },
			{ path: '/connections', name: 'Connections', component: () => import('@/views/connection/ConnectionList'), meta: { title: '连接管理' } },
			{ path: '/connections/:id', name: 'ConnectionDetail', component: () => import('@/views/connection/ConnectionDetail'), meta: { title: '话题详情' } },
			{ path: '/dreams/users/:userId', name: 'UserDreams', component: () => import('@/views/dream/UserDreamCalendar'), meta: { title: '用户梦境' } },
			{ path: '/dreams', name: 'Dreams', component: () => import('@/views/dream/DreamList'), meta: { title: '梦境列表' } },
			{ path: '/settings', name: 'CommonSettings', component: () => import('@/views/config/CommonSettings'), meta: { title: '公共配置', requiresSuper: true } },
			{ path: '/mini-configs', name: 'MiniConfigs', component: () => import('@/views/config/MiniConfigs'), meta: { title: '小程序配置', requiresSuper: true } },
			{ path: '/admins', name: 'SystemAdmins', component: () => import('@/views/system/SystemAdmins'), meta: { title: '系统用户', requiresSuper: true } },
			{ path: '/admin-login-logs', name: 'AdminLoginLogs', component: () => import('@/views/system/AdminLoginLogs'), meta: { title: '管理员登录日志', requiresSuper: true } }
		]
	},
	{ path: '*', redirect: '/users', hidden: true }
]

const createRouter = () => new VueRouter({ mode: 'hash', routes })
const router = createRouter()

export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher
}

export default router
